import React from 'react';
// @ts-ignore
import {Link as RouterLink} from "react-router-dom";
// @ts-ignore
import {Link as ScrollLink} from "react-scroll";
import {FlexedDiv, RowDiv} from "../styledComponents/CustomStyledComponents";
import Constants from "../../data/Constants";
import ImageComponent from "../imageEconomicResearch/EconomicResearchImageComponent";
import Images from "../../assets/images/Images";
import './IndexEconomicResearchStyle.css'
import { Trans, useTranslation } from 'react-i18next';

const IndexComponent: React.FC<{ items: { label: string, to: string }[] }> = ({items}) => {
    return (
        <div className='index-container'>
            {
                items.map((item, index) => {
                    return (
                        <div style={{marginLeft: 40}}>
                            <ScrollLink
                                key={index}
                                className='index-scroll'
                                to={item.to}
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500}
                            >
                                {item.label}
                            </ScrollLink>
                        </div>
                    )
                })
            }
        </div>
    );
};

const TextComponent: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className='text-container'>
            <div className='text-title' style={{color: '#737373'}}>{ t('economicResearch.mainSection.title') }</div>
            <FlexedDiv flexValue={1}/>
            <FlexedDiv style={{fontFamily: 'Mapfre-Light', lineHeight: 2}} flexValue={5}>
              <Trans i18nKey='economicResearch.mainSection.description'>
                Description <RouterLink to='/bps'></RouterLink> description
              </Trans>
            </FlexedDiv>
        </div>
    );
};

const SeparatorComponent: React.FC = () => {
    return (
        <React.Fragment>
            <FlexedDiv flexValue={0.15} />
            <FlexedDiv flexValue={0} style={{ borderLeft: '4px solid #737373', maxHeight: 80, marginTop: 5}} />
            <FlexedDiv flexValue={0.15} />
        </React.Fragment>
    )
};

interface Props {
    scrollLinks: { label: string, to: string }[]
}

const IndexEconomicResearchComponent: React.FC<Props> = ({ scrollLinks }) => {
    return (
        <RowDiv style={{height: `90vh`, alignItems: 'center', color: 'black'}}>
            <RowDiv style={{flex: 1}}>
                <IndexComponent items={scrollLinks}/>
                <SeparatorComponent/>
                <TextComponent />
            </RowDiv>
            <RowDiv style={{flex: 1, height: '100%'}}>
              <RowDiv className='index-image-container'>
                  <ImageComponent
                      image={Images.homeImage2}
                      imageStyle={{height: 400}}
                  />
              </RowDiv>
          </RowDiv>
        </RowDiv>
    );
};

export default IndexEconomicResearchComponent;
